import IconButton from './IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const TableDeleteActionButton = ({clickHandler, idx, children}) => {
    return (
        <IconButton onClick={() => clickHandler(idx)}>
            {!children ? <DeleteOutlineIcon color="error"/> : children }
        </IconButton>
    );
};
export default TableDeleteActionButton;